import React from 'react';
import useUserPermissions from '../hooks/useUserPermissions';

/**
 * ProtectedRoute - Wrapper component to protect routes based on user permissions
 * @param {React.Component} children - The component to render if user has permission
 * @param {boolean} requireModify - If true, only admins and ops-specialists can access
 */
function ProtectedRoute({ children, requireModify = false }) {
    const { canModify, isLoading } = useUserPermissions();

    // Show loading state while checking permissions
    if (isLoading) {
        return (
            <div className="container-fluid mt-5">
                <div className="text-center">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                    <p className="mt-2">Checking permissions...</p>
                </div>
            </div>
        );
    }

    // Check if user has required permissions
    if (requireModify && !canModify()) {
        return (
            <div className="container-fluid mt-5">
                <div className="alert alert-danger" role="alert">
                    <h4 className="alert-heading">Access Denied</h4>
                    <p>You do not have permission to access this page.</p>
                    <hr />
                    <p className="mb-0">Only administrators and operations specialists can access draft runbooks.</p>
                </div>
                <button 
                    className="btn btn-primary mt-3"
                    onClick={() => window.history.back()}
                >
                    Go Back
                </button>
            </div>
        );
    }

    // User has permission, render the protected component
    return children;
}

export default ProtectedRoute;
